import { Sport } from '__generated__/globalTypes';
import { unitMapping } from 'lib/style';

import { Ball } from './Ball';
import { MLBBall } from './MLBBall';
import { NBABall } from './NBABall';

const iconPerSport = {
  [Sport.FOOTBALL]: Ball,
  [Sport.NBA]: NBABall,
  [Sport.BASEBALL]: MLBBall,
};

type Props = {
  sport: Sport;
  className?: string;
  size?: keyof typeof unitMapping;
};

export const SportBall = ({ sport, className, size = 2 }: Props) => {
  const Icon = iconPerSport[sport];

  return <Icon size={size} className={className} />;
};
